export const ApiDocumentTypes = {
    Drawing: "Drawing",
    ShopDrawing: "ShopDrawing",
    RFI: "RFI",
    Contract: "Contract",
    Submittal: "Submittal",
    Code: "Code",
    IFOA: "IFOA",
    PrimeContract: "PrimeContract",
    Supplemental: "Supplemental",
    Generic: "Generic",
    CSI: "CSI",
    AzDOT: "AzDOT",
    TxDOT: "TxDOT",
    Schedule: "Schedule",
    FinishSpec: "FinishSpec",
};

export type ApiDocumentType = (typeof ApiDocumentTypes)[keyof typeof ApiDocumentTypes];

/** URL aliases for project document owners. Order is the endpoint query order. */
export const DOCUMENT_ALIASES = {
    sheets: ApiDocumentTypes.Drawing,
    specs: ApiDocumentTypes.CSI,
    ifoa: ApiDocumentTypes.IFOA,
    primecontract: ApiDocumentTypes.PrimeContract,
    schedule: ApiDocumentTypes.Schedule,
} as const;

export type DocumentAlias = keyof typeof DOCUMENT_ALIASES;

export const DOCUMENT_ALIAS_TYPES = Object.freeze(Object.values(DOCUMENT_ALIASES));

/** Canonical specification types and their section-group batch query tokens. */
const SPECIFICATION_DOCUMENT_TYPE_QUERIES = [
    { documentType: ApiDocumentTypes.CSI, query: "csi" },
    { documentType: ApiDocumentTypes.AzDOT, query: "azdot" },
    { documentType: ApiDocumentTypes.TxDOT, query: "txdot" },
] as const;

export const SPECIFICATION_DOCUMENT_TYPES = Object.freeze(
    SPECIFICATION_DOCUMENT_TYPE_QUERIES.map(({ documentType }) => documentType),
);

/** Existing set-shaped API. New code can use `SPECIFICATION_DOCUMENT_TYPES`. */
export const SPEC_DOCUMENT_TYPES: ReadonlySet<string> = new Set(
    SPECIFICATION_DOCUMENT_TYPES,
);
